import React from 'react';
import { InputFormGroup, LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { ValidationGroup, Input } from '@bingads-webui-react/primitive-validation';
import { Constants, TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { InputTaxFieldId } from '../constants';
import { registerTaxform } from '../taxform-store';
import { withViewTaxFormWithFilledEmptyTaxValue, getHelpPopupTopicFromTaxSchema, getTaxTypeLabel } from '../utils';
import { CustomValidateItems, validateField } from '../validator';
import { useValidationI18n } from '../hooks/use-i18n';

const { TaxLabelFormat, TaxType } = Constants;
const { isNZGSTNumberValid } = TaxUtils;

// New Zealand tax fields look like xx-xxx-xxx or xxx-xxx-xxx, and dashes is inserted automatically if not typed by user
// So far, this is the only tax field that behaves this way in old UI
export function formatNewZealandTaxData(taxData) {
  const td = taxData;
  if (td.NZGSTNumber != null) {
    let val = td.NZGSTNumber;
    // Add in a dash every three characters, starting from index location 2 or 3 depending on whether or not the string length is more than 8 characters
    // The oldui component first deletes user-entered dashes
    val = val.split('').filter(char => char !== '-').join('');
    // then puts dashes at index location 2 and 6 if necessary based on length of string
    if (val.length <= 8) {
      // e.g. xx-x
      if (val.length >= 3) {
        val = `${val.slice(0, 2)}-${val.slice(2)}`;
      }
      // e.g. xx-xxx-xx
      if (val.length >= 7) {
        val = `${val.slice(0, 6)}-${val.slice(6)}`;
      }
    } else {
      // in this case, insert a dash every 3 characters in string
      val = val.match(/.{1,3}/g).join('-');
    }
    td.NZGSTNumber = val;
  }
  return td;
}

const NZTaxSchema = {
  name: 'New Zealand Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.NZGSTNumber]: {
      type: 'string',
      required: false,
      helpPopupTopic: 'pop_BA_Accounts_NZGST',
    },
  },
};

const NZTaxForm = (props) => {
  const validationI18n = useValidationI18n(props.i18n);
  const CustomizedFormGroup = props.showLineByLineFormGroup ? LineByLineFormGroup : InputFormGroup;

  return (
    <ValidationGroup
      validationProps={{
        schema: NZTaxSchema,
        i18n: validationI18n,
        onValidate: props.onValidate,
        data: formatNewZealandTaxData(props.data),
      }}
    >
      <CustomizedFormGroup
        isStatic
        label={getTaxTypeLabel(TaxType.NZGSTNumber, props.i18n, { labelFormat: TaxLabelFormat.Optional })}
        helpPopupTopic={getHelpPopupTopicFromTaxSchema({ taxSchema: NZTaxSchema, taxType: TaxType.NZGSTNumber })}
      >
        <Input
          id={InputTaxFieldId(TaxType.NZGSTNumber)}
          validationProps={{
            field: TaxType.NZGSTNumber,
            alwaysShowError: props.alwaysShowError,
            validator: value => validateField(
              value,
              {},
              { [CustomValidateItems.NZGSTNumberValidation]: inputValue => inputValue.length > 0 && !isNZGSTNumberValid(inputValue) },
              props.i18n
            ),
          }}
          disabled={props.disabled}
        />
      </CustomizedFormGroup>
    </ValidationGroup>
  );
};

NZTaxForm.propTypes = TaxTypeFormPropTypes;

registerTaxform('/NZ/', NZTaxForm, withViewTaxFormWithFilledEmptyTaxValue({ getTaxSchema: () => NZTaxSchema }));
